import { render, staticRenderFns } from "./ProjectPostingItemArchiveModal.vue?vue&type=template&id=4fac7bbb"
import script from "./ProjectPostingItemArchiveModal.vue?vue&type=script&lang=js"
export * from "./ProjectPostingItemArchiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports